import { useOutletContext } from "react-router-dom";
import StrategyPanel from "../../components/StrategyPanel";

export default function PortalStrategy() {
  const { summary } = useOutletContext();
  if (!summary) return <div className="p-8 text-neutral-500">Loading…</div>;
  const client = summary.client;
  return (
    <div className="p-6 md:p-8 space-y-6 max-w-[1400px]">
      <div>
        <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-orange-400">The Playbook</div>
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Your Social Strategy</h1>
        <p className="text-neutral-600 text-sm mt-1">The plan your team is executing every week.</p>
      </div>
      <StrategyPanel clientId={client.id} clientName={client.client_name} readOnly/>
    </div>
  );
}
